// @core/api/endpoints/activity/acknowledge_activities.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AcknowledgeActivitiesRequest,
  AcknowledgeActivitiesResponse,
} from '../../../types/activity';

const BASE_PATH = '/activity';

/**
 * Acknowledge activities
 * Marks specific activities as acknowledged for the current user. Acknowledged activities are removed from the active Inbox view.
 */
export async function AcknowledgeActivities(
  data: AcknowledgeActivitiesRequest,
  options?: RequestOptions
): Promise<AcknowledgeActivitiesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/inbox/acknowledge`;
  const requestOptions = options;
  return client.post<AcknowledgeActivitiesResponse>(requestPath, data, requestOptions);
}
